import styled from 'styled-components'

export const Wrapper = styled.div`
  background: #fff;
  max-width: 1050px;
  margin: 0 auto;
  min-height: calc(100vh - 107px);
`
